"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITokenFrozen = exports.ITokenInactive = exports.ITokenPayment = void 0;
var ITokenPayment;
(function (ITokenPayment) {
    ITokenPayment[ITokenPayment["AMERICAN_EXPRESS_1"] = 1] = "AMERICAN_EXPRESS_1";
    ITokenPayment[ITokenPayment["VISA_2"] = 2] = "VISA_2";
    ITokenPayment[ITokenPayment["MASTERCARD_3"] = 3] = "MASTERCARD_3";
    ITokenPayment[ITokenPayment["DINERS_CLUB_4"] = 4] = "DINERS_CLUB_4";
    ITokenPayment[ITokenPayment["DISCOVER_5"] = 5] = "DISCOVER_5";
    ITokenPayment[ITokenPayment["CHECKING_ACCOUNT_8"] = 8] = "CHECKING_ACCOUNT_8";
    ITokenPayment[ITokenPayment["SAVINGS_ACCOUNT_9"] = 9] = "SAVINGS_ACCOUNT_9";
    ITokenPayment[ITokenPayment["CORPORATE_CHECKING_ACCOUNT_10"] = 10] = "CORPORATE_CHECKING_ACCOUNT_10";
    ITokenPayment[ITokenPayment["CORPORATE_SAVINGS_ACCOUNT_11"] = 11] = "CORPORATE_SAVINGS_ACCOUNT_11";
})(ITokenPayment = exports.ITokenPayment || (exports.ITokenPayment = {}));
var ITokenInactive;
(function (ITokenInactive) {
    ITokenInactive[ITokenInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    ITokenInactive[ITokenInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(ITokenInactive = exports.ITokenInactive || (exports.ITokenInactive = {}));
var ITokenFrozen;
(function (ITokenFrozen) {
    ITokenFrozen[ITokenFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    ITokenFrozen[ITokenFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(ITokenFrozen = exports.ITokenFrozen || (exports.ITokenFrozen = {}));
